<ng-template #scholarsCell let-activity>
  @for (
    contributor of activity.contributors;
    track contributor;
    let i = $index
  ) {
    <div [ngClass]="{ hidden: i > 0 && !activity.collaboratorsAreExpanded }">
      <a
        [routerLink]="contributor | personUrl"
        queryParamsHandling="merge"
        class="link"
        tabindex="0"
        [attr.aria-label]="
          personNamePipe.transform(contributor, true) + ' Profile'
        "
      >
        <span>{{ contributor | personName: true }}</span>
      </a>
      @if (activity.contributors.length > 1 && i === 0) {
        <a
          (click)="
            activity.collaboratorsAreExpanded =
              !activity?.collaboratorsAreExpanded
          "
          (keyup.enter)="
            activity.collaboratorsAreExpanded =
              !activity?.collaboratorsAreExpanded
          "
          class="expand-collaborators-link"
          tabindex="0"
          [attr.aria-label]="
            (activity.collaboratorsAreExpanded ? 'Hide ' : 'Show ') +
            'Collaborators'
          "
        >
          {{ activity.collaboratorsAreExpanded ? ' -' : ' +' }}
        </a>
      }
    </div>
  }
</ng-template>

<ng-template #unitsCell let-activity>
  @for (
    contributor of activity.contributors;
    track contributor;
    let i = $index
  ) {
    <div
      [ngClass]="{
        hidden: i > 0 && !activity.collaboratorsAreExpanded,
        link:
          _context.dashboardUnitTypes?.includes(
            contributor.primaryUnitAffiliation ?
              contributor.primaryUnitAffiliation.type
            : null
          ) &&
          !_context.unitBlacklist?.includes(
            contributor.primaryUnitAffiliation?.id
          ),
      }"
      (click)="
        selectUnit(
          contributor.primaryUnitAffiliation,
          contributor.primaryInstitution
        )
      "
      (keyup.enter)="
        selectUnit(
          contributor.primaryUnitAffiliation,
          contributor.primaryInstitution
        )
      "
      tabindex="0"
    >
      {{
        (contributor && contributor.primaryUnitAffiliation ?
          contributor.primaryUnitAffiliation.baseName
        : '') +
          ((
            _context.useCombinedSystemDashboard &&
            contributor?.primaryInstitution
          ) ?
            ' - ' + contributor.primaryInstitution.shortName
          : '')
      }}
    </div>
  }
</ng-template>
<ng-template #titlesCell let-activity>
  <div>
    @switch (activity.activityType) {
      @case (ActivityType.Article) {
        <div>
          @if (activity.doi) {
            <a
              href="javascript:void(0);"
              (click)="openUrl(getDoiUrl(activity.doi))"
              class="link"
              tabindex="0"
              [attr.aria-label]="activity.title"
            >
              <span>{{ activity.title | striphtml }}</span>
            </a>
          }
          @if (!activity.doi) {
            <div>
              <span>{{ activity.title | striphtml }}</span>
            </div>
          }
        </div>
      }
      @case (ActivityType.ConferenceProceeding) {
        <div>
          @if (activity.doi) {
            <a
              href="javascript:void(0);"
              (click)="openUrl(getDoiUrl(activity.doi))"
              class="link"
              tabindex="0"
              [attr.aria-label]="activity.title"
            >
              <span>{{ activity.title | striphtml }}</span>
            </a>
          }
          @if (!activity.doi) {
            <div>
              <span>{{ activity.title | striphtml }}</span>
            </div>
          }
        </div>
      }
      @case (ActivityType.ClinicalTrial) {
        <div>
          @if (activity.nctId) {
            <a
              href="javascript:void(0);"
              (click)="openUrl(getTrialUrl(activity.nctId))"
              class="link"
              tabindex="0"
              [attr.aria-label]="activity.title"
            >
              <span>{{ activity.title | striphtml }}</span>
            </a>
          }
          @if (!activity.nctId) {
            <div>
              <span>{{ activity.title | striphtml }}</span>
            </div>
          }
        </div>
      }
    }
  </div>
</ng-template>

<app-breadcrumb [useThemeColor]="true"></app-breadcrumb>
@if (!hideResearchAtAGlance) {
  <div class="heading-container">
    <h1 class="main-heading header-text" id="raag-main-heading">
      {{ headingText }}
    </h1>
    <h2 class="sub-heading header-text">
      {{ researchActivitiesText }} {{ subHeadingLevelText }} faculty over the
      past 36 months.
    </h2>
  </div>
}

@if ((carouselItems | async) !== null) {
  <aa-carousel
    dataQaTag="raag-carousel"
    [items]="carouselItems | async"
    [attr.aria-controls]="'recent-activities-container'"
    (clickedItem)="selectActivity($event)"
    [selectedItem]="selectedActivityObj.value"
  ></aa-carousel>
}

@if (!hideResearchAtAGlance) {
  <div
    id="recent-activities-container"
    data-qa="raag-recent-activities"
    [attr.aria-live]="'polite'"
  >
    @if (metricResults.length > 0) {
      <div class="recent-activities-header-row">
        <h2 class="recent-activities-header">
          {{ selectedActivityName }}
        </h2>
        <button
          class="view-all-button"
          data-qa="raag-view-all-toggle"
          (click)="toggleViewAll(selectedActivityObj.value)"
          [innerHTML]="viewButtonText"
          [attr.aria-label]="viewButtonText + ' ' + selectedActivityName"
        ></button>
      </div>
    }
    @if ((results | async) !== null) {
      <aa-grid
        [ngClass]="{ expanded: viewAllSelected }"
        [columnHeaderDefinitions]="columnHeaderDefinitions | async"
        [rowDefinition]="rowDefinition | async"
        [records]="results | async"
        [enablePagination]="true"
        [clientSidePaging]="false"
        [(currentPage)]="currentPage"
        [endPage]="endPage"
        (currentPageChange)="updatePage($event)"
        [pageScrollTop]="false"
      >
      </aa-grid>
    }
  </div>
}
